import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import TabItem from "./tabItem";
import * as styles from './tabs.module.css';
import { gsap, TweenMax, Expo } from "gsap";



function tabs(props) {

    const [activeTab, setActiveTab] = useState(0);
    const [activeTabOptions, setActiveTabOptions] = useState(0);

    const sectionRef = useRef();
    const contentRef = useRef();

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([contentRef.current], {
        //     opacity: 0,
        //     x: 80
        // });

        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){

                    // TweenMax.to(
                    //     contentRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         x: 0, 
                    //         delay : 0.25,
                    //         onComplete : () => {
                    //             $(sectionRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );

                    $(sectionRef.current).addClass('anim-complete');
                }
            });
        } else {
            TweenMax.set([contentRef.current], {
                opacity: 1,
                x: 0
            });
        }

    });

    function toggleTab(key, label){
        setActiveTab(key);
        $('.tbi-tab-item').hide();
        $('*[data-tbindex="tbi-'+key+'"]').fadeIn(250, () => {
        });
        label = (label== 'All') ? 'View All' : label;
        $('.tabMobileValue span').text(label);
        $('.tabMobileValue').attr('data-value', key);
        $('.tabOptions').slideUp(200);
    }

    function toggleOptions(){
        setActiveTabOptions(!activeTabOptions);
        $('.tabOptions').slideToggle(200);
    }

    let bgImageDesktop = (props.bgimagedesktop) ? props.bgimagedesktop.image.asset.url : false;
    let iconClass = 'fas fa-chevron-down';
    let tabOptionValueClass = styles.mobileTabValue + ' tabMobileValue';
    let tabOptionsClass = styles.mobileTabOptions + ' tabOptions';
    if(activeTabOptions == 1){
        tabOptionValueClass += ' '+styles.mobileTabOptions__active;
    }

    return (
        <div className={styles.tabSection} ref={sectionRef}>
            <div className={styles.sectionBackground} style={{ backgroundImage : `url("${bgImageDesktop}")`}}></div>
            <div className={styles.sectionContainer}>
                <div className={styles.containerInner} ref={contentRef}>
                    <div className={styles.textWrap}>
                        <h2>{props.heading}</h2>
                    </div>
                    <div className={styles.tabWrap}>
                        <div className={styles.tabLabelWrap}>
                            {
                                props.tabs.map((item, i) => {

                                    let labelClass = styles.tabLabel;
                                    if(i == activeTab){
                                        labelClass += ' '+styles.tabLabel__active;
                                    }

                                    return (
                                        <div className={labelClass} key={i} onClick={ () => toggleTab(i, item.title) }>
                                            {item.title}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className={styles.mobileTabSelect}>
                            <div className={tabOptionValueClass} data-value="0" onClick={ () => toggleOptions() }>
                                <span>View All</span>
                                <i className={iconClass}></i> 
                            </div>
                            <div className={tabOptionsClass}>
                                {
                                    props.tabs.map((item, i) => {
                                        return (
                                            <div className={styles.tabOption} key={i} onClick={ () => toggleTab(i, item.title) }>
                                                { (item.title == 'All') ? 'View All' : item.title }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className={styles.tabContentWrap}>
                            {
                                props.tabs.map((item, i) => {
                                    return <TabItem item={item} key={i} index={i} activeTab={activeTab} />
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default tabs;